"use client"

import type React from "react"
import { useState } from "react"
import { faSave } from "@fortawesome/free-solid-svg-icons"
import ButtonCustomIcon from "../../../utils/custom-button-icon"
import ExitDraftModal from "./ExitDraftModal"
import AnonymousModalPaiement from "../AnonymousModalPaiement"
import useAppContext from "../../../hooks/useAppContext"
import type { AppContextType } from "../../../context/AppContext"
import type { UserModel } from "../../../models/UserModel"
import { useDispatch } from 'react-redux';
import { setUser } from '../../../userSlice';

type DraftSaveButtonProps = {
  defaultEmail?: string,
  onSaveDraft: (email: string) => void
}

const DraftSaveButton: React.FC<DraftSaveButtonProps> = ({ defaultEmail, onSaveDraft }) => {
  const dispatch = useDispatch();
  const [showExitDraftModal, setShowExitDraftModal] = useState(false)
  const [showAnonymousModal, setShowAnonymousModal] = useState(false)
  const [userDetails, setUserDetails] = useState<UserModel | null>(null)
  const [wasAnonymous, setWasAnonymous] = useState(false);

  const { selectedType, setAuthenticatedUser } = useAppContext() as AppContextType

  const userStatus =
    typeof window !== "undefined"
      ? localStorage.getItem("userStatus") ?? "anonymous"
      : "anonymous"

const handleOpenModal = () => {
  if (!selectedType || !selectedType.sSType) {
    alert("Veuillez d'abord sélectionner un type d'annonce avant de sauvegarder.")
    return
  }

  if (userStatus === "anonymous") {
    setWasAnonymous(true);
    setShowAnonymousModal(true)
  } else {
    setShowExitDraftModal(true)
  }
}


  const handleCloseExitDraftModal = () => {
    setShowExitDraftModal(false)
  }

  const handleCloseAnonymousModal = () => {
    setShowAnonymousModal(false)
  }

  // const handleAnonymousRegistrationSuccess = () => {
  //   // Après inscription réussie, fermer le modal d'inscription et ouvrir celui de sauvegarde
  //   // Utiliser un délai pour s'assurer que le modal se ferme proprement
  //   setTimeout(() => {
  //     setShowAnonymousModal(false)
  //     setShowExitDraftModal(true)
  //   }, 500)
  // }

  const handleAnonymousRegistrationSuccess = (user: UserModel) => {
  // 1️⃣ Mettre à jour le contexte global
  setAuthenticatedUser(user);
  dispatch(setUser(user));

  // 2️⃣ Mettre à jour le localStorage
    localStorage.setItem("userStatus", "registered");
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("userId", user.id.toString());
    localStorage.setItem("role", user.role || "CLIENT");
    localStorage.setItem("wasAnonymous", "true");

  // 3️⃣ Fermer modal inscription
  setShowAnonymousModal(false);

  // 4️⃣ Ouvrir modal sauvegarde
  setShowExitDraftModal(true);
};

   const handleDraftSaveSuccess = () => {
    console.log("✅ Sauvegarde terminée, vérification du rechargement...");
    
    if (wasAnonymous) {
      console.log("🔄 Ex-utilisateur anonyme détecté, rechargement de la page...");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <ButtonCustomIcon title="Sauvegarder dans mes brouillons" icon={faSave} color="#2A9D8F" onClick={handleOpenModal} />
      </div>
      
      {/* Modal d'inscription pour les utilisateurs anonymes */}
      <AnonymousModalPaiement 
        isModalVisible={showAnonymousModal} 
        handleModalClose={handleCloseAnonymousModal}
        userDetails={userDetails}
        setUserDetails={setUserDetails}
        onRegistrationComplete={handleAnonymousRegistrationSuccess}
        isDraft ={true}
      />

      {/* Modal de sauvegarde du brouillon */}
      <ExitDraftModal 
        isOpen={showExitDraftModal} 
        onCancel={handleCloseExitDraftModal} 
        onSaveDraft={onSaveDraft} 
        defaultEmail={defaultEmail} 
        status={userStatus}
        onSuccess={handleDraftSaveSuccess}
      />

    </>
  )
}

export default DraftSaveButton
